"use client"

import * as TabsPrimitive from "@radix-ui/react-tabs"
import * as React from "react"

import { cn } from "../../utils"

function Tabs({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Root>) {
	return <TabsPrimitive.Root data-slot="tabs" className={cn("h-full flex flex-col", className)} {...props} />
}

function TabsList({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.List>) {
	return (
		<TabsPrimitive.List
			data-slot="tabs-list"
			className={cn(
				"shrink-0 inline-flex w-full items-center space-x-4.5 inset-shadow-[0_-1px_0_var(--divider)]",
				"data-[size=medium]:h-12 data-[size=small]:h-9.5",
				"data-[variant=standard]:justify-start data-[variant=standard]:[&_button]:flex-initial",
				"data-[variant=centered]:justify-center data-[variant=centered]:[&_button]:flex-initial",
				"data-[variant=fullWidth]:w-full data-[variant=fullWidth]:space-x-0",
				"[&_.render-action]:ml-auto",
				className
			)}
			{...props}
		/>
	)
}

function TabsTrigger({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
	return (
		<TabsPrimitive.Trigger
			data-slot="tabs-trigger"
			className={cn(
				"text-text-tertiary hover:text-text-secondary inset-shadow-[0_-2px_0_rgba(0,0,0,0)] cursor-pointer",
				"inline-flex h-full flex-1 items-center justify-center gap-1 text-lg font-bold whitespace-nowrap",
				"transition-[color,box-shadow] disabled:pointer-events-none disabled:text-text-disabled disabled:cursor-default",
				"[&_.prefix]:fill-current [&_svg]:pointer-events-none [&_svg]:shrink-0",
				"data-[size=medium]:text-lg data-[size=medium]:[&_.prefix]:w-5 data-[size=medium]:[&_.prefix]:h-5",
				"data-[size=small]:text-base data-[size=small]:[&_.prefix]:w-4 data-[size=small]:[&_.prefix]:h-4",
				"data-[state=active]:text-text data-[state=active]:inset-shadow-[0_-2px_0_var(--text)]",
				"[&_.trigger-warp]:flex [&_.trigger-warp]:items-center [&_.trigger-warp_.prefix]:mr-1.5 [&_.trigger-warp_.suffix]:ml-1.5",
				"[&_.badge]:flex [&_.badge]:items-center [&_.badge]:justify-center [&_.badge]:w-4 [&_.badge]:h-4 [&_.badge]:rounded-lg [&_.badge]:bg-error [&_.badge]:text-white [&_.badge]:text-xs [&_.badge]:font-bold",
				className
			)}
			{...props}
		/>
	)
}

function TabsContent({ className, ...props }: React.ComponentProps<typeof TabsPrimitive.Content>) {
	return <TabsPrimitive.Content data-slot="tabs-content" className={cn("flex-1 flex flex-col outline-none", className)} {...props} />
}

export { Tabs, TabsContent, TabsList, TabsTrigger }
